import { render, staticRenderFns } from "./InputPrice.vue?vue&type=template&id=38c81132"
import script from "./InputPrice.vue?vue&type=script&lang=ts"
export * from "./InputPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports